import EventEmitter from "eventemitter3";
import { StoryNodeDisplayType } from "../domain/StoryNodeDisplayType";
export class FunctionBase {
    constructor(brainClient, authStore) {
        this.brainClient = brainClient;
        this.authStore = authStore;
    }
    // TODO: input 定义优化，统一传入 SearchInfoPagination，去掉 page 和 next
    async run(input, identityInfo, variableList = [], page = 1, next = undefined, // for food
    pagination = undefined, // for youtube
    requestParams = {}, // for additional required data
    checkAbort, sourceNodeType = StoryNodeDisplayType.TEXT, queries = [], blueprintJSON = "", graphData) {
        return Promise.reject();
    }
}
export var FuncResponseType;
(function (FuncResponseType) {
    FuncResponseType["TEXT"] = "TEXT";
    FuncResponseType["STREAM_TEXT"] = "STREAM_TEXT";
    FuncResponseType["STRING_GROUP"] = "STRING_GROUP";
    FuncResponseType["STOCK"] = "STOCK";
    FuncResponseType["STOCK_GROUP"] = "STOCK_GROUP";
    FuncResponseType["AMAZON_SHOPPING"] = "AMAZON_SHOPPING";
    FuncResponseType["JD_SHOPPING"] = "JD_SHOPPING";
    FuncResponseType["YOUTUBE_VIDEOS"] = "YOUTUBE_VIDEOS";
    FuncResponseType["WEEE_GROCERIES"] = "WEEE_GROCERIES";
    FuncResponseType["WEEE_SHOPPING"] = "WEEE_SHOPPING";
    FuncResponseType["MAP"] = "MAP";
    FuncResponseType["IMAGE_GROUP"] = "IMAGE_GROUP";
    FuncResponseType["FOOD"] = "FOOD";
    FuncResponseType["ASK_BRAIN"] = "ASK_BRAIN";
    FuncResponseType["PROTEIN"] = "PROTEIN";
    FuncResponseType["MIDJOURNEY"] = "MIDJOURNEY";
    FuncResponseType["IMAGE_TEXT"] = "IMAGE_TEXT";
    FuncResponseType["CHAT_INTERFACE"] = "CHAT_INTERFACE";
    FuncResponseType["CUSTOM_API"] = "CUSTOM_API";
    FuncResponseType["INTERVIEW_BOT"] = "INTERVIEW_BOT";
    FuncResponseType["BLUEPRINT"] = "BLUEPRINT";
})(FuncResponseType || (FuncResponseType = {}));
export class FuncResponse {
    constructor(type, data) {
        this.type = type;
        this.data = data;
    }
}
export class RunStreamResponse {
    constructor() {
        this.eventEmitter = new EventEmitter();
        this.response = undefined;
    }
    onReceived(listener) {
        if (this.response) {
            listener(this.response);
        }
        this.eventEmitter.on(RunStreamResponse.RECEIVED_EVENT, msg => {
            listener(msg);
        });
    }
    receive(newValue, completion, error) {
        const result = new RunStreamResponseStreamResult(newValue, completion, error);
        this.response = result;
        if (this.eventEmitter.listenerCount(RunStreamResponse.RECEIVED_EVENT) > 0) {
            this.eventEmitter.emit(RunStreamResponse.RECEIVED_EVENT, result);
        }
    }
}
RunStreamResponse.RECEIVED_EVENT = "RunStreamResponseReceived";
export class RunStreamResponseStreamResult {
    constructor(value, completion, error) {
        this.value = value;
        this.completion = completion;
        this.error = error;
    }
}
export class FuncCustomVariable {
    constructor(name, value) {
        this.name = name;
        this.value = value;
    }
}
